/**
 * CoSingery — **邀請碼狀態**（Beta；`decisions/042`）
 *
 * 為何要抽成 hook：登入頁已經接近硬規則 B 嘅 200 行上限；而且「由 `?invite=` 帶入 → 記落
 *   `localStorage` → 下次自動填」係一段有自己生命週期嘅邏輯（同一份唔應該散喺頁面度）。
 *
 * ⚠️ 前端**唔准**判斷邀請碼對唔對（只有 server 知 `sha256`）—— 呢度只負責「記住同交出」。
 */
import { useState } from 'react';

const STORAGE_KEY = 'cosingery.invite';

/** 由 URL（`?invite=`）或上次記住嘅值開始 */
export function useInviteCode(fromUrl: string | null): [string, (v: string) => void] {
  const [invite, setInvite] = useState<string>(() => {
    const url = (fromUrl ?? '').trim();
    if (url) {
      try {
        localStorage.setItem(STORAGE_KEY, url);
      } catch {
        /* 私隱模式 */
      }
      return url;
    }
    try {
      return localStorage.getItem(STORAGE_KEY) ?? '';
    } catch {
      return '';
    }
  });

  /**
   * 用戶手動改 → 一齊記住（大寫化；唔准喺呢度驗證格式）。
   * ⚠️ **只記邀請碼**（有字母）—— 6 位一次性數碼**唔准**寫入 `localStorage`
   *   （唔係下次開頁會自動填一個已死嘅碼 → 自動登入失敗，嚇親用戶）。
   */
  const update = (v: string) => {
    const next = v.toUpperCase();
    setInvite(next);
    try {
      if (next.trim() && /[A-Z]/.test(next)) localStorage.setItem(STORAGE_KEY, next.trim());
    } catch {
      /* 私隱模式 */
    }
  };

  return [invite, update];
}
